// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"226c8d25","69":"fbd31174","136":"3da31753","288":"5ddb2487","680":"13e170dd","690":"492fb88f","734":"e4248055"}[chunkId] + ".chunk.js";
};